import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UnsupportedBrowserGuard } from 'pages/unsupported-browser';
import { AnalyticsProvider, RequestTrackingPermission } from 'features/tracking';
import { LoggerProvider } from 'shared/lib/logger';
import { LocalizationContextProvider } from 'shared/lib/localization';
import { resolveServices } from '../lib/resolve-services';
import { UifConfigProvider } from './UIFConfigProvider';
import { QueryProvider } from './QueryProvider';
import '@kl/components-v6/design-system/global-style/styles.css';
import { ErrorBoundary } from './ErrorBoundary';

export const PluginRoot: FC<PropsWithChildren> = ({ children }) => {
    const { t, i18n } = useTranslation();
    const { localization, logger, events } = resolveServices(i18n, t);

    useEffect(() => {
        logger.log(`Enterprise portal plugin version ${process.env.REACT_APP_PLUGIN_VERSION}`);
    }, []);

    return (
        <UifConfigProvider>
            <LocalizationContextProvider eventsService={events} localizationService={localization}>
                <LoggerProvider logger={logger}>
                    <QueryProvider>
                        <ErrorBoundary>
                            <AnalyticsProvider>
                                <RequestTrackingPermission />
                                <UnsupportedBrowserGuard>{children}</UnsupportedBrowserGuard>
                            </AnalyticsProvider>
                        </ErrorBoundary>
                    </QueryProvider>
                </LoggerProvider>
            </LocalizationContextProvider>
        </UifConfigProvider>
    );
};
